import React , {Component} from "react";
import MyContext from '../MyContext.jsx';
import {Link} from "react-router-dom";
import { CgSearch } from 'react-icons/cg';
import Select from "react-select";
import DatePicker from 'react-date-picker';


import './AllowanceReport.scss';

class AllowanceReport extends Component{
  constructor(props){
    super(props);
    this.executiveSelect = React.createRef();

    this.state = {
      executives    :   [],
      executive :   {},
      allowances : [],
      showing_allowances:[],
      search:'',
      from_date : new Date(),
      to_date : new Date(),
    }
    this.executiveChange = this.executiveChange.bind(this);
    this.formSubmit = this.formSubmit.bind(this);


  }
  componentDidMount(){
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/Reports/getExecutives`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
         executives : return_data.executives,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
        obj_this.context.loading(0);
        alert("Network error");
    });

    
  }

  executiveChange(option){
    this.setState({
      executive : option
    });
  } 

  formSubmit(e){
    e.preventDefault();
    $(".customer_outstandings_table tr").css("backgroud-color","");
    if(!this.state.executive.value){
      this.executiveSelect.current.focus();
      return;
    }
    
    var obj_this = this;
    const url2 = `${process.env.REACT_APP_SSS}/api/Reports/getAllowanceReport`;
    this.context.loading(1);
    $.ajax({
      url : url2,
      data : {
        sid : this.context.user_details.sid,
        executive_id : this.state.executive.value,
        from_date : this.state.from_date.toLocaleDateString('en-CA'),
        to_date : this.state.to_date.toLocaleDateString('en-CA')
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      
      if(return_data.status == "success"){
        obj_this.setState({
         allowances : return_data.cost,
         showing_allowances:return_data.cost,
         total:return_data.total
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
    });
   
    
  }

  fromDateChange(value){
    // console.log(value);
    this.setState({from_date : value});
  }
  toDateChange(value){
    // console.log(value);
    this.setState({to_date : value});
  }




  
    

  render(){
    return(
      <MyContext.Consumer>
        {context => (
        <div className="allowance_request_page_container">
          <div className="page_header">
            <Link className="back_button" to="/reports"><i className="fas fa-arrow-left"></i></Link>
            <div className="page_title">Allowance Report</div>
          </div> 
          <form className="executive_due_period_form" onSubmit={this.formSubmit}>
            <div className="blocks">
            <div className="input_grid">
                <div className="form_input">
                <div className="from_to_label">
                    <div className="input_label">From Date</div>
                    <DatePicker
                      className="input custom_input"
                      onChange={(value) => this.fromDateChange(value)}
                      value={this.state.from_date}
                      // minDate = {new Date()}
                      clearIcon={null}
                      required
                      format="dd-MM-y"
                    />
                    <div className="input_label">To Date</div>
                    <DatePicker
                      className="input custom_input"
                      onChange={(value) => this.toDateChange(value)}
                      value={this.state.to_date}
                      minDate = {new Date(this.state.from_date)}
                      clearIcon={null}
                      required
                      format="dd-MM-y"
                    />
                  </div>
                  <div className="input_label">Executive</div>
                  <Select 
                    options={this.state.executives}  
                    value ={this.state.executive}
                    className="executive" 
                    ref={this.executiveSelect}
                    onChange={e => this.executiveChange(e)}
                    required
                  />
                 
                  <div className="submit_button_container">
                    <button className="submit_button">Submit</button>
                  </div>
                </div>
                
                </div>
                
            </div>
          </form>
          
          <div className="table_container">
            <table className="customer_outstandings_table">
              <thead>
                <tr>
                  <th style={{maxWidth:"40px"}} align="center">#</th>
                  <th colSpan="4">Allowances</th>
                </tr>
              </thead>
              <tbody>
              <tr style={{display:this.state.showing_allowances.length?"none":"table-row"}}>
                <td colSpan="5" align="center">No result!</td>
              </tr>
              {this.state.showing_allowances && this.state.showing_allowances.map((cust,index) => (
                <tr key={index} >
                  <td valign="top" align="center">{index+1}</td>
                  <td valign="top" style={{padding:"5px 0px"}}>
                    <div style={{fontWeight:"500",paddingLeft:"5px"}}>{cust.ta_head_id==1?'Travel':cust.ta_head_id==6?'Food':cust.ta_head_id==8?'Others':''}</div>
                   
                  </td>
                  
                  <td valign="top" style={{padding:"5px 0px"}}>
                    <div style={{fontWeight:"500",paddingLeft:"5px"}}>{cust.cost}</div>
                   
                  </td>
                  
                </tr>
              ))}
              <tr style={{display:this.state.showing_allowances.length?"table-row":"none"}}><td colSpan="2" align="center" >Total</td> <td>{this.state.total}</td></tr>
              </tbody>
            </table>
          </div>
        </div>

      )}
    </MyContext.Consumer>
  )}
}

export default AllowanceReport;
AllowanceReport.contextType = MyContext;
